import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceBattery', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceBatteryService.js